import { Link } from "react-router-dom";
import { createPortal } from "react-dom";

const Navbar = ({ navItems, onClose }) => {
    return createPortal (
        <div className="fixed inset-0 bg-gray-50 z-40 px-6 pt-28 dark:bg-black md:hidden">

            <nav className="flex flex-col">
                {navItems.map((item) => (
                    <Link
                        key={item.path}
                        to={item.path}
                        onClick={onClose}
                        className="group flex items-center justify-between border-b border-gray-200 py-6 text-xl font-bold tracking-tight text-gray-900 dark:border-gray-800 dark:text-white"
                    >
                        <span className="transition-transform duration-300 group-hover:translate-x-2">
                            {item.label}
                        </span>

                        <span className="text-gray-400 transition-transform duration-300 group-hover:translate-x-2">
                            →
                        </span>
                    </Link>
                ))}
            </nav>

        </div>, document.body
    );
};

export default Navbar;